/** @jsx jsx */
import { ReactNode } from "react";
import { jsx } from "theme-ui"

export default function Button({children, bright, onClick, active, secondary, activated, ssx={},}: {
  children: ReactNode;
  onClick: () => void;
  active?: boolean;
  secondary?: boolean;
  bright?: boolean;
  activated?: boolean;
  ssx?: {};
}) {
  return <button 
    sx={{
      color: activated ? 'primary' : !secondary ? 'primary' : 'secondary',
      backgroundColor: activated ? 'secondary' : bright ? 'bright' : !secondary ? 'secondary' : 'primary',
      fontSize: 2,
      fontWeight: 'body',
      paddingY: 2,
      paddingX: 3,
      borderColor: active ? 'primary' : 'primaryLight', 
      borderWidth: '1px',
      borderStyle: 'solid',
      borderRadius: 4,
      textTransform: 'uppercase',
      ...ssx,
    }} 
    onClick={onClick}
  >{children}</button>
}
